import { UPLOAD_DOCUMENT_PATH } from "config/envConfig";

/** Paths relative to `API_BASE_URL`, for use with `lib/api`: `api.get(API_ENDPOINTS.me)` */
export const API_ENDPOINTS = {
  login: "/api/auth/login",
  logout: "/api/auth/logout",
  me: "/api/auth/me",
  profile: "/api/auth/profile",
  changePassword: "/api/auth/change-password",
  forgotPassword: "/api/auth/forgot-password",
  resetPassword: "/api/auth/reset-password",
  uploadFile: "/api/uploads/upload-file",
  uploadDocument: UPLOAD_DOCUMENT_PATH || "/api/uploads/upload-file",
  users: "/api/admin/investors",
   /** Admin update  profile (phone, name, etc.). */
   adminInvestorProfile: (id) =>
    `/api/admin/investors/${encodeURIComponent(String(id))}/profile`,
  /** Admin update investor account status (`active` | `inactive`). */
  adminInvestorStatus: (id) =>
    `/api/admin/investors/${encodeURIComponent(String(id))}/status`,
  projects: "/api/admin/projects",
  /** Admin single-project fetch/update (same resource as list). */
  adminProjectById: (id) => `/api/admin/projects/${encodeURIComponent(String(id))}`,
  projectDetail: (id) => `/api/projects/${id}`,

  transactions: "/api/admin/investments",
  cancellationRequests: "/api/admin/cancellation-requests",
  cancellationRequestApprove: (id) =>
    `/api/admin/cancellation-requests/${encodeURIComponent(String(id))}/approve`,
  cancellationRequestReject: (id) =>
    `/api/admin/cancellation-requests/${encodeURIComponent(String(id))}/reject`,
  auditLogs: "/api/admin/audit-logs",
  industries: "/api/admin/industries",
  industryById: (id) => `/api/admin/industries/${encodeURIComponent(String(id))}`,

  health: "/health",
};
